import L from 'leaflet';
import './control.pos.less';

const { Control, DomUtil } = L;

/*
 * @class Control.Pos
 * @aka L.Control.Pos
 * @inherits Control
 *
 * A simple pos control that shows the pos of the current center of screen in metric (m/km) and imperial (mi/ft) systems. Extends `Control`.
 *
 * @example
 *
 * ```js
 * L.control.pos().addTo(map);
 * ```
 */

const Pos = Control.extend({
  // @section
  // @aka Control.Pos options
  options: {
    position: 'bottomright',

    // @option maxWidth: Number = 100
    // Maximum width of the control in pixels. The width is set dynamically to show round values (e.g. 100, 200, 500).
    maxWidth: 100
  },

  onAdd: function(map) {
    var container = DomUtil.create('div', 'leaflet-control-pos');
    // options = this.options;

    this.pos = DomUtil.create('div', '', container);

    map.on('mousemove', this._update, this);
    map.whenReady(this._update, this);

    return container;
  },

  onRemove: function(map) {
    map.off('mousemove', this._update, this);
  },

  getLat(latlng) {
    if (!latlng) return '--';
    const value = latlng.lat;
    if (value > 90) {
      return -(180 - value).toFixed(6);
    }
    if (value < -90) {
      return (180 + value).toFixed(6);
    }
    return value.toFixed(6);
  },

  getLng(latlng) {
    if (!latlng) return '--';
    const value = latlng.lng;
    if (value > 180) {
      return -(360 - value).toFixed(6);
    }
    if (value < -180) {
      return (360 + value).toFixed(6);
    }
    return value.toFixed(6);
  },

  _update: function(e) {
    const { latlng } = e;
    this.pos.innerHTML = `<p>纬度&nbsp;${this.getLat(
      latlng
    )}°&nbsp;&nbsp;&nbsp;经度&nbsp; ${this.getLng(latlng)}°</p>`;
  }
});

L.Control.Pos = Pos;

// @factory L.control.pos(options?: Control.Pos options)
// Creates an pos control with the given options.
L.control.pos = function(options) {
  return new Pos(options);
};
